import { render, staticRenderFns } from "./InspectionReportEdit1.vue?vue&type=template&id=b844870e&"
import script from "./InspectionReportEdit1.vue?vue&type=script&lang=js&"
export * from "./InspectionReportEdit1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports